import React, { useCallback, useEffect, useState } from 'react';
import * as S from './styles';
import { Container, Grid } from 'rsuite';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { TamanhoPizza } from '../../components/TamanhoPizza';
import { useAuth } from '../../hooks/auth';

import api from '../../services/api';

import { CreateSize } from './components/CreateSize';
import { tableFields } from './constants/table-fields';
import { CustomButton } from '../../components/CustomButton';
import { toastSuccess } from '../../toasts';
import { FaPizzaSlice } from 'react-icons/fa';
import { useCustomTheme } from '../../hooks/useCustomTheme';

export const TamanhosPizzas = () => {
  const { id_empresa } = useAuth();
  const { theme } = useCustomTheme();
  const [sizes, setSizes] = useState([]);
  const [selectedsSizes, setSelectedsSizes] = useState([]);

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const newItems = Array.from(sizes);
      const [reorderedItem] = newItems.splice(dragIndex, 1);
      newItems.splice(hoverIndex, 0, reorderedItem);

      setSizes(newItems);
    },
    [sizes],
  );

  async function handleSaveEditSequence() {
    try {
      const updateSizesPromisses = sizes.map((size, index) =>
        api.patch(`/tamanho/alterar/${size?.Id}`, {
          Sequencia: index + 1,
        }),
      );

      Promise.all(updateSizesPromisses);

      toastSuccess('Sequencia salva com sucesso!');
    } catch (err) {
      console.log(err);
    }
  }

  const listSizes = useCallback(async () => {
    try {
      const { data } = await api.get(`tamanho/listar_pizzas/${id_empresa}`);

      if (!Array.isArray(data) || data?.length === 0) {
        return;
      }

      setSizes(data);
    } catch (err) {
      console.error(err);
    }
  }, [id_empresa]);

  useEffect(() => {
    listSizes();
  }, [listSizes]);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Tamanhos Pizzas"
        subtitle="Gerencie os tamanhos de pizza disponíveis"
        icon={FaPizzaSlice}
        thirdComponent={<DuvidasButton tela="tamanhos-pizzas" />}
      />
      <S.Content>
        <CreateSize setSizes={setSizes} />

        <S.SectionHeader>
          <S.SectionTitle>
            Tamanhos cadastrados{sizes.length > 0 ? ` (${sizes.length})` : ''}
          </S.SectionTitle>
          {sizes.length > 0 && <S.DragHint>Arraste para reordenar</S.DragHint>}
        </S.SectionHeader>

        {sizes.length === 0 ? (
          <S.EmptyState>
            <S.EmptyStateTitle>Nenhum tamanho cadastrado</S.EmptyStateTitle>
            <S.EmptyStateText>
              Use o card acima para adicionar os tamanhos de pizza disponíveis.
            </S.EmptyStateText>
          </S.EmptyState>
        ) : (
          <S.ContainerSize hasTamanhos>
            <Grid style={{ width: '100%' }}>
              <S.StyledRow>
                {tableFields.map(([_description, size]) => (
                  <S.StyledCol key={_description || 'actions'} xs={size}>
                    {_description}
                  </S.StyledCol>
                ))}
              </S.StyledRow>
              {sizes.map((item, index) => (
                <TamanhoPizza
                  key={item.Id}
                  item={item}
                  handleSetTamanhos={setSizes}
                  tamanhos={sizes}
                  setSelectedsSizes={setSelectedsSizes}
                  selectedsSizes={selectedsSizes}
                  moveCard={moveCard}
                  index={index}
                  isManaging={true}
                />
              ))}
            </Grid>
          </S.ContainerSize>
        )}

        {sizes.length > 0 && (
          <S.SaveSequence>
            <CustomButton onClick={handleSaveEditSequence}>
              Salvar sequencia
            </CustomButton>
          </S.SaveSequence>
        )}
      </S.Content>
    </Container>
  );
};
